export const frameworkLabels = {
  next: "Next.js",
  nuxt: "Nuxt",
  sveltekit: "SvelteKit",
  other: "Other"
} as const
